module.exports = __webpack_public_path__ + "img/green-check-circle-icon.f6da6178.svg";